<script>
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	export let lists = [];
	export let showScore = false;
	const names = ["učení", "opakování", "z fronty", "ze zapomenutých"];

	function random(songs) {
		return songs[Math.floor(Math.random() * songs.length)];
	};

	function getRandSong(songs, sum) {
		let p = Math.random() * sum;
		for (let s of songs) {
			p -= s.tot;
			if (p <= 0)
				return s;
		}
	}

	function randomByWeight(songs) {
		const now = Date.now();
		const w = songs.map(s => ({song: s, score: s.getScore(now)}));
		w.sort((a, b) => a.score - b.score);
		let sum = 0;
		for (let s of w) {
			s.tot = sum * 0.3 + s.score;
			sum += s.tot;
		}
		return getRandSong(w, sum).song;
	}

	function setRandomSong(songs, weights) {
		if (!songs.length)
			return;
		const song = weights ? randomByWeight(songs) : random(songs);
		if (song)
			dispatch('setActSong', song);
	}

	function getScoreSum(songs) {
		const now = Date.now();
		return Math.round(songs.reduce((v, s) => v + s.getScore(now), 0));
	}
</script>

Vybrat náhodnou písničku:
{#each lists as it, i}
	{#if it.list.length}
	<button class="typebtn" style:background-color={it.category.color}
		on:click={(e) => setRandomSong(it.noToday, it.category.weight)}
	>
		{names[i]}
		({it.noToday.length})
		{#if it.category.weight && showScore}
			({getScoreSum(it.noToday)})
		{/if}
	</button>
	{/if}
{/each}
